import React from 'react';
import { motion } from 'framer-motion';
import { skeletonVariants } from '../utils/animationVariants';
import '../styles/SkeletonLoader.css';

export const SkeletonCard = ({ className = '' }) => (
  <motion.div
    className={`skeleton-card glass-card ${className}`}
    variants={skeletonVariants}
    initial="initial"
    animate="animate"
  >
    <div className="skeleton-shimmer">
      <div className="skeleton-text skeleton-title"></div>
      <div className="skeleton-text skeleton-line"></div>
      <div className="skeleton-text skeleton-line-short"></div>
    </div>
  </motion.div>
);

export const SkeletonText = ({ width = '100%', height = '20px', className = '' }) => (
  <motion.div
    className={`skeleton-text ${className}`}
    style={{ width, height }}
    variants={skeletonVariants}
    initial="initial"
    animate="animate"
  />
);

export const SkeletonCircle = ({ size = '48px', className = '' }) => (
  <motion.div
    className={`skeleton-circle ${className}`}
    style={{ width: size, height: size }}
    variants={skeletonVariants}
    initial="initial"
    animate="animate"
  />
);

export const SkeletonTable = ({ rows = 5, columns = 4 }) => (
  <div className="skeleton-table">
    <div className="skeleton-table-header">
      {[...Array(columns)].map((_, i) => (
        <SkeletonText key={i} height="24px" />
      ))}
    </div>
    <div className="skeleton-table-body">
      {[...Array(rows)].map((_, rowIndex) => (
        <div key={rowIndex} className="skeleton-table-row">
          {[...Array(columns)].map((_, colIndex) => (
            <SkeletonText key={colIndex} height="20px" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonImage = ({ width = '100%', height = '200px', className = '' }) => (
  <motion.div
    className={`skeleton-image ${className}`}
    style={{ width, height }}
    variants={skeletonVariants}
    initial="initial"
    animate="animate"
  />
);

export const SkeletonPage = () => (
  <div className="page-container">
    <div className="page-header">
      <SkeletonText width="250px" height="40px" className="mb-sm" />
      <SkeletonText width="400px" height="20px" />
    </div>
    <div className="page-content">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-lg">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard className="lg:hidden" />
        <SkeletonCard className="lg:hidden" />
      </div>
    </div>
  </div>
);

export default SkeletonCard;
